import { createContext, useContext } from 'react'

export type FeedContextValue = {
  fetchMoreNewer: () => Promise<void>
  markAsUnread: (createdAt: Date) => void
}

export const FeedContext = createContext<FeedContextValue>({
  fetchMoreNewer: () => Promise.resolve(undefined),
  markAsUnread: () => undefined,
})

export const useFeedContext = () => useContext(FeedContext)
